<div class="modal-content">

  <div class="modal-header">
    <h3 class="modal-title font">{{titulo}}</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <!-- Formulario ambito geografico -->
    <form class="form-modal py-3" [formGroup]="formGroup">

      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="comunidad">Comunidad <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field-width">
              <mat-select formControlName="comunidad" id="comunidad" placeholder="Comunidad">
                <mat-option *ngFor="let comunidad of comunidades" [value]="comunidad.id">
                  {{comunidad.nombre}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="controlHasError('comunidad', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm flex-grow-1">
          <label for="codigoLer">Código LER <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field-width">
              <mat-select formControlName="codigoLer" id="codigoLer" placeholder="Código LER">
                <mat-option *ngFor="let codigoLer of codigosLer" [value]="codigoLer.id">
                  {{codigoLer.tipoCodigo}} - {{ codigoLer.descripcion }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="controlHasError('codigoLer', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="cantidad_t">Cantidades anuales acordadas (t) <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field-width">
              <input formControlName="cantidad_t" id="cantidad_t" placeholder="Cantidades anuales acordadas (t)"
                matInput type="number" min="0">
              <mat-error *ngIf="controlHasError('cantidad_t', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('cantidad_t', 'min')">El valor debe ser mayor o igual a 0</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
    <!-- FIN Formulario ambito geografico -->
  </div>
  <div class="modal-footer actions">
    <div class="note">* Campos Obligatorios</div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="comprobarGuardar()"
        aria-label="Guardar">Guardar</button>
    </div>
  </div>
</div>
